import BroadcastTokenApi from "@/api/BroadcastTokenApi";
import SupabaseApi from "@/api/SupabaseApi";

// OBS 방송 토큰 캐싱 (네임스페이스 모듈). 토큰은 펫 단위 → 선택 펫 기준으로 발급/캐시.
export default {
  namespaced: true,
  state: () => ({
    token: null, // 캐시된 OBS 토큰
    tokenPetId: null, // 캐시된 토큰이 어느 펫 것인지 (선택 펫 변경 시 무효화)
  }),
  mutations: {
    setToken(state, { token, petId }) {
      state.token = token;
      state.tokenPetId = petId;
    },
    clearToken(state) {
      state.token = null;
      state.tokenPetId = null; // 로그아웃/계정 전환 시 호출 권장
    },
  },
  actions: {
    // 선택 펫 토큰 확보: 같은 펫이면 캐시 반환, 다르면(또는 없으면) 서버 발급(ensure) 후 캐시.
    async ensureToken({ state, commit }) {
      const petId = await SupabaseApi.UserStatus.fetchSelectedPetId();
      if (state.token && state.tokenPetId === petId) return state.token;
      const token = await BroadcastTokenApi.ensureToken(petId);
      commit("setToken", { token, petId });
      return token;
    },
    // 재발급(회전) — 선택 펫 토큰을 항상 새로 발급하고 캐시 갱신 (기존 링크 무효)
    async regenerateToken({ commit }) {
      const petId = await SupabaseApi.UserStatus.fetchSelectedPetId();
      const token = await BroadcastTokenApi.regenerateToken(petId);
      commit("setToken", { token, petId });
      return token;
    },
  },
};
